import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useCreateProjectMutation, useSetProjectSubNameMutation, useGetLibrariesQuery } from '../../../generated/graphql';
import { FormAutoComplete, FormField, FormTextArea } from '../../form';
import styles from './NewProjectDialog.module.css';

type NewProjectDialogProps = {
    onClose: () => void,
    clientId: string | undefined | null,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewProjectDialog = (props: NewProjectDialogProps) => {
    const { style, visible, clientId, onClose } = props;
    const [createProject, createProjectResult] = useCreateProjectMutation();
    const [setProjectSubName] = useSetProjectSubNameMutation();
    const [name, setName] = useState('');
    const [searchText, setSearchText] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');

    const libraryData = useGetLibrariesQuery({
        variables: { clientId, contains: searchText }
    });

    const handleSubmit = () => {
        const selected = libraryData.data?.LibraryList?.nodes?.filter(l => l?.name === searchText)[0];

        if (!name || !description) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!searchText) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selected) {
            setValidationError('Please Select A Valid Library!');
            return;
        }
        setValidationError('');
        const projectId = crypto.randomUUID();
        createProject({
            variables: {
                project: {
                    id: projectId,
                    name,
                    description,
                    clientId,
                    libraryId: selected?.id || ""
                }
            }
        })
            .then(() => {
                return setProjectSubName({
                    variables: {
                        projectId,
                        projectSubName: name
                    }
                });
            })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            isLoading={createProjectResult.loading}
            title="New Project"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewProjectDialog}
            style={style}
            data-testid="NewProjectDialog">
            <FormField label="Project Name" name="name" value={name} onChange={setName} />
            <FormAutoComplete
                label="Library"
                name="library"
                value={searchText}
                onChange={setSearchText}
                options={(libraryData.data?.LibraryList?.nodes?.map(l => l?.name) || []).filter((n): n is string => !!n)}
            />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default NewProjectDialog;